/**
 * Per-framework readiness route shim.
 *
 * Prefetches the readiness report and mounts the page.
 */

import { createFileRoute } from "@tanstack/react-router";
import { complianceDetailSearchSchema } from "@/features/compliance/navigation";
import { fetchReadinessReport } from "@/features/compliance/queries";
import { ReadinessPage } from "@/features/compliance/pages/readiness-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion/readiness",
)({
  validateSearch: (raw: Record<string, unknown>) => complianceDetailSearchSchema.parse(raw),
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: [
        "compliance-v2",
        "readiness",
        context.tenant.id,
        params.frameworkId,
        params.frameworkVersion,
      ],
      queryFn: () =>
        fetchReadinessReport(
          context.tenant.id,
          params.frameworkId,
          params.frameworkVersion,
        ),
    }),
  component: ReadinessPage,
});
